<template>
	<div class="popup popup--middle" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Восстановление пароля</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__description">Уважаемые пользователи, логин и пароль выдается менеджером организации. <br> Для восстановления логина или пароля заполните форму ниже, и менеджер вышлет логин и пароль на указанную вами при регистрации почту.<br>  Если у Вас изменилась электронная почта или контактные данные, свяжитесь с нами по телефону 8 800 600 96 69</div>
			<hr/>
			<div class="popup__content">
				<form class="popup__form">
					<div class="form__inputs form__inputs--2">
						<InputText :label="'Организация'" v-model="formData.company" :placeholder="'Введите название организации'" :errors="v$.formData.company.$errors"/>
						<InputText :label="'ИНН'" :placeholder="'Введите ИНН'" :number="12" v-model="formData.inn" :errors="v$.formData.inn.$errors"/>
					</div>
					<div class="form__inputs form__inputs--3">
						<InputText :label="'Контактное лицо'" :placeholder="'Введите имя'"  v-model="formData.name" :errors="v$.formData.name.$errors"/>
						<InputText :label="'E-mail'" :placeholder="'Введите E-mail'"  v-model="formData.email" :errors="v$.formData.email.$errors"/>
						<InputText :label="'Телефон для связи'" :placeholder="'+7'" :phone="true"  v-model="formData.phone" :errors="v$.formData.phone.$errors"/>
					</div>
					<div class="form__submit">
						<button class="form__submit-btn btn btn--border" @click.prevent="checkReCaptcha">Отправить</button>
						<div class="form__submit-description">Нажимая кнопку «Отправить», Вы даете согласие на обработку <a target="_blank" :href="staticData.personalLink">персональных данных</a></div>
					</div>
					<hr>
					<div class="form__back">
						<div class="form__back-title">Вспомнили пароль?</div>
						<div class="form__back-btn btn btn--color" @click="$emit('close')">Перейти к авторизации</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import useVuelidate from "@vuelidate/core";
import objectToFormData from "@/utils/ObjectToFormData";
import staticData from '@/enums/staticData';
import Fetch from "@/utils/Fetch";
import { useToast } from "vue-toastification";
import {required, helpers, email, minLength, maxLength} from '@vuelidate/validators'
const {withMessage} = helpers

const checkLength  = (min,max) => (value) => {
	if(value.length === min || value.length === max){
		return true
	}
	return false
}


export default {
	name: "ResetPasswordPopup",
	components: {InputText},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			ShowResetPasswordPopup: false,
			toast: useToast(),
			formData: {
				company: '',
				inn: '',
				name: '',
				email: '',
				phone: ''
			}
		}
	},
	methods: {
		async checkReCaptcha(e) {
			e.preventDefault();
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}
			// eslint-disable-next-line no-undef
			grecaptcha.ready(() => {
				// eslint-disable-next-line no-undef
				grecaptcha.execute('6Le-0jsmAAAAANJNzqizBZv0AZCkt7xN3OkDdRCR', {action: 'submit'}).then(async (token) => {
					await this.sendForm(token)
				});
			});
		},

		async sendForm(token) {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}

			const body = objectToFormData({
				company: this.formData.company,
				inn: this.formData.inn,
				name: this.formData.name,
				email: this.formData.email,
				phone: this.formData.phone,
				token
			})

			let response = await Fetch('user/password/recovery/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success('Ваш запрос успешно отправлен');
				this.$emit('close')
			} else {
				this.toast.error(response.message);
			}

		}
	},
	computed: {
		staticData() {
			return staticData
		}
	},
	validations() {
		return {
			formData: {
				company: {
					required: withMessage("Заполните организациюю", required),
				},
				inn: {
					checkLength: withMessage('В ИНН должно быть 10 или 12 цифр', checkLength(10,12))
				},
				name: {
					required: withMessage("Заполните Имя", required),
				},
				email: {
					email: withMessage('Неверный формат электронной почты', email),
					required: withMessage('Заполните E-mail', required),
				},
				phone: {
					required: withMessage("Заполните телефон", required),
					minLength: withMessage("В номере телефона должно быть минимум 8 цифр", minLength(9)),
					maxLength: withMessage("В номере телефона должно быть максимум 15 цифр", maxLength(16)),
				},
			}
		}
	},

}
</script>


